export const SitterTraits = {
  CHILDREN_AT_HOME: 'childrenAtHome',
  FIRST_AID_CERTIFICATE: 'firstAidCertificate',
  HAS_PETS: 'hasPets',
  HAS_POLICE_CHECK_BADGE: 'hasPoliceCheckBadge',
  RESPONSE_WITH_IN_AN_HOUR: 'responseWithinAnHour',
};
